import classnames from 'classnames';
import style from '../tree-navigation.module.less';

export const Label = ({ count, label }) => {
  return (
    <div
      className={classnames(style['label-overflow'], {
        [style['has-badge']]: count,
      })}
    >
      {label}
    </div>
  );
};
